module.exports = __webpack_public_path__ + "media/honey-icons/icon-home-type-detached-3d723c80.svg";